export default "__VITE_ASSET__Betqq6rU__"